"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopperTooltip = _interopRequireDefault(require("react-popper-tooltip"));

var _Tooltip = require("./Tooltip.style");

var _excluded = ["children", "tooltip", "offset", "arrow", "width", "zIndex"];

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      _tooltip = _ref.tooltip,
      offset = _ref.offset,
      arrow = _ref.arrow,
      width = _ref.width,
      zIndex = _ref.zIndex,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var isValid = _tooltip && ( /*#__PURE__*/_react["default"].isValidElement(_tooltip) || _tooltip.length);

  return /*#__PURE__*/_react["default"].createElement(_reactPopperTooltip["default"], (0, _extends2["default"])({}, props, {
    modifiers: {
      name: 'offset',
      enabled: true,
      options: {
        offset: offset || [0, 5]
      }
    },
    tooltip: function tooltip(_ref2) {
      var _getTooltipProps;

      var arrowRef = _ref2.arrowRef,
          tooltipRef = _ref2.tooltipRef,
          getArrowProps = _ref2.getArrowProps,
          getTooltipProps = _ref2.getTooltipProps,
          placement = _ref2.placement;
      return /*#__PURE__*/_react["default"].createElement(_Tooltip.StyledTooltip, (0, _extends2["default"])({}, getTooltipProps((_getTooltipProps = {
        ref: tooltipRef,
        className: 'eui-tooltip-container'
      }, (0, _defineProperty2["default"])(_getTooltipProps, 'data-popper-placement', placement), (0, _defineProperty2["default"])(_getTooltipProps, "width", width), _getTooltipProps)), {
        isValid: isValid,
        zIndex: zIndex
      }), arrow && /*#__PURE__*/_react["default"].createElement("div", getArrowProps({
        'ref': arrowRef,
        'className': 'tooltip-arrow',
        'data-placement': placement
      })), _tooltip);
    }
  }), function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    return /*#__PURE__*/_react["default"].createElement("span", getTriggerProps({
      ref: triggerRef,
      className: 'trigger'
    }), children);
  });
};

Tooltip.defaultProps = {
  arrow: false,
  placement: 'top'
};
Tooltip.propTypes = {
  children: _propTypes["default"].node,
  tooltip: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  offset: _propTypes["default"].array,
  arrow: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  placement: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
  zIndex: _propTypes["default"].number
};
var _default = Tooltip;
exports["default"] = _default;